import Nav from "./Nav";
//import Likes from "./Likes";
import Comments from "./Comments";
import RemoveButton from "./RemoveButton";
//import { ToastContainer, toast } from "react-toastify";
import { toast } from "react-toastify";


import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Auth, API , graphqlOperation } from 'aws-amplify'
import { createTodo, createMetric, updateMetric } from '../graphql/mutations'
import {  listUpdates, todosByDate, listMetrics, getMetric  } from '../graphql/queries'
import { withAuthenticator  } from '@aws-amplify/ui-react';
import { Header } from "../Header";
import { Footer } from "../Footer";
import { SignInHeader } from "../SignInHeader";
import { SignUpHeader } from "../SignUpHeader";
import { SignInFooter } from "../SignInFooter";
//import { SignUpFooter } from "./SignUpFooter";
import {
 // Flex,
//  Heading,
  Image,
//  View,
} from "@aws-amplify/ui-react";
import img1 from "../logo192.png";
import logo from '../logo.svg';


function useInterval(callback, delay) {
    const savedCallback = useRef();
  
    // Remember the latest callback.
    useEffect(() => {
      savedCallback.current = callback;
    }, [callback]);
  
    // Set up the interval.
    useEffect(() => {
      let id = setInterval(() => {
        savedCallback.current();
      }, delay);
      return () => clearInterval(id);
    }, [delay]);
  }


//const Home = () => {

function Home({signOut,user}) {



    const navigate = useNavigate();
    function snotify(note) {toast.success(note);};
    //function inotify(note) {toast.info(note)};
    //function enotify(note) {toast.error(note)};
    //function wnotify(note) {toast.warning(note)};

    const [opt, setOpt] = useState('0');
    const [opt2, setOpt2] = useState('0');
    const [todos, setTodos] = useState([]);
    const [metrics, setMetrics] = useState([]);  
    const [metricId, setMetricId] = useState('');
    const [bot1, setBot1] = useState('0');
    const [bot2, setBot2] = useState('0');
    const [bot3, setBot3] = useState('0');
    const [bot4, setBot4] = useState('0');
    //const [threadList, setThreadList] = useState([]);
    //const [threadList2, setThreadList2] = useState([]);

    //const [thread, setThread] = useState("");
    const [thread2, setThread2] = useState("");
    const [loader, setLoader] = useState("1")

      //AutoUpdate from backend
      var tmpcnt = 60000;
      useInterval(() => {
       

        if (opt==='1') {
          //Skip while creating new todo
        } else {
          fetchTodos();
          fetchMetrics();
        };

          


  
      }, tmpcnt);
    
   

    //👇🏻 The useEffect Hook
    useEffect(() => {

        const fetchTodos2 = async () => {
            try {
                const todoData = await API.graphql(graphqlOperation( todosByDate,   {type: 'todo' ,  sortDirection: 'ASC'}   ));
               // console.log(todoData);
               // const todoList = todoData.data.listTodos.items;
               const todoList = todoData.data.todosByDate.items;
             //   console.log('todo list', todoList);
                setTodos(todoList);
                setLoader('0');
            } catch (error) {
                console.log('error on fetching todos', error);
            }
        };
    

        const fetchMetrics2 = async () => {
          var metric = 0;
          try {
              const todoData = await API.graphql(graphqlOperation( listMetrics ));
           //   console.log(todoData);
             // const todoList = todoData.data.listTodos.items;
             const todoList = todoData.data.listMetrics.items;
            //  console.log('metrics list', todoList);
              setMetrics(todoList);
           //   setLoader('0');
              metric = 1;
              var tmpId = todoData.data.listMetrics.items[0].id
              setMetricId(tmpId);
              setBot1(todoData.data.listMetrics.items[0].bot1);
              setBot2(todoData.data.listMetrics.items[0].bot2);
              setBot3(todoData.data.listMetrics.items[0].bot3);
              setBot4(todoData.data.listMetrics.items[0].bot4);



          } catch (error) {
              console.log('error on fetching metrics', error);
          }


          if (metric === 0) {
            //Create First Metric
            alert("Creating Main Metric Record");
            newMetric();
          }
    



      };


        fetchTodos2();
        fetchMetrics2();
     
    }, [navigate]);

    async function fetchTodos() {
        try {//alert('Ft');
            const todoData = await API.graphql(graphqlOperation( todosByDate,   {type: 'todo' ,  sortDirection: 'ASC'}   ));
         //   console.log(todoData);
           // const todoList = todoData.data.listTodos.items;
           const todoList = todoData.data.todosByDate.items;
            //console.log('todo list', todoList);
            setTodos(todoList);
            setLoader('0');
        } catch (error) {
            console.log('error on fetching todos', error);
        }
    };


    

    async function fetchUpdates() {
      try {
          const todoData = await API.graphql(graphqlOperation( listUpdates));
       //   console.log(todoData);
         // const todoList = todoData.data.listTodos.items;
       //  const todoList = todoData.data.listUpdates.items;
        //  console.log('updates list', todoList);
          alert(todoData.data.listUpdates.items.length)
       //   setTodos(todoList);
        //  setLoader('0');
      } catch (error) {
          console.log('error on fetching update list', error);
      }
  };

  async function fetchMetrics() {
    try {
           //refresh metrics
            var replyData = await API.graphql(graphqlOperation(getMetric    ,   {id: metricId }  ));
       //     console.log(replyData);
       setBot1(replyData.data.getMetric.bot1);
       setBot2(replyData.data.getMetric.bot2);
       setBot3(replyData.data.getMetric.bot3);
       setBot4(replyData.data.getMetric.bot4);
    } catch (error) {
        console.log('error on fetching update list', error);
    }
};



// /function blank(){};



/////////////////////////////////////////////////////////////////////////////////////////////////
/*
 * Date Format 1.2.3
 * (c) 2007-2009 Steven Levithan <stevenlevithan.com>
 * MIT license
 *
 * Includes enhancements by Scott Trenda <scott.trenda.net>
 * and Kris Kowal <cixar.com/~kris.kowal/>
 *
 * Accepts a date, a mask, or a date and a mask.
 * Returns a formatted version of the given date.
 * The date defaults to the current date/time.
 * The mask defaults to dateFormat.masks.default.
 */

var dateFormat = function () {
	var	token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g,
		timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
		timezoneClip = /[^-+\dA-Z]/g,
		pad = function (val, len) {
			val = String(val);
			len = len || 2;
			while (val.length < len) val = "0" + val;
			return val;
		};

	// Regexes and supporting functions are cached through closure
	return function (date, mask, utc) {
		var dF = dateFormat;

		// You can't provide utc if you skip other args (use the "UTC:" mask prefix)
		if (arguments.length == 1 && Object.prototype.toString.call(date) == "[object String]" && !/\d/.test(date)) {
			mask = date;
			date = undefined;
		}

		// Passing date through Date applies Date.parse, if necessary
		date = date ? new Date(date) : new Date;
		if (isNaN(date)) throw SyntaxError("invalid date");

		mask = String(dF.masks[mask] || mask || dF.masks["default"]);

		// Allow setting the utc argument via the mask
		if (mask.slice(0, 4) == "UTC:") {
			mask = mask.slice(4);
			utc = true;
		}

		var	_ = utc ? "getUTC" : "get",
			d = date[_ + "Date"](),
			D = date[_ + "Day"](),
			m = date[_ + "Month"](),
			y = date[_ + "FullYear"](),
			H = date[_ + "Hours"](),
			M = date[_ + "Minutes"](),
			s = date[_ + "Seconds"](),
			L = date[_ + "Milliseconds"](),
			o = utc ? 0 : date.getTimezoneOffset(),
			flags = {
				d:    d,
				dd:   pad(d),
				ddd:  dF.i18n.dayNames[D],
				dddd: dF.i18n.dayNames[D + 7],
				m:    m + 1,
				mm:   pad(m + 1),
				mmm:  dF.i18n.monthNames[m],
				mmmm: dF.i18n.monthNames[m + 12],
				yy:   String(y).slice(2),
				yyyy: y,
				h:    H % 12 || 12,
				hh:   pad(H % 12 || 12),
				H:    H,
				HH:   pad(H),
				M:    M,
				MM:   pad(M),
				s:    s,
				ss:   pad(s),
				l:    pad(L, 3),
				L:    pad(L > 99 ? Math.round(L / 10) : L),
				t:    H < 12 ? "a"  : "p",
				tt:   H < 12 ? "am" : "pm",
				T:    H < 12 ? "A"  : "P",
				TT:   H < 12 ? "AM" : "PM",
				Z:    utc ? "UTC" : (String(date).match(timezone) || [""]).pop().replace(timezoneClip, ""),
				o:    (o > 0 ? "-" : "+") + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
				S:    ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10]
			};

		return mask.replace(token, function ($0) {
			return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
		});
	};
}();

// Some common format strings
dateFormat.masks = {
	"default":      "ddd mmm dd yyyy HH:MM:ss",
	shortDate:      "m/d/yy",
	mediumDate:     "mmm d, yyyy",
	longDate:       "mmmm d, yyyy",
	fullDate:       "dddd, mmmm d, yyyy",
	shortTime:      "h:MM TT",
	mediumTime:     "h:MM:ss TT",
	longTime:       "h:MM:ss TT Z",
	isoDate:        "yyyy-mm-dd",
	isoTime:        "HH:MM:ss",
	isoDateTime:    "yyyy-mm-dd'T'HH:MM:ss",
	isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
};

// Internationalization strings
dateFormat.i18n = {
	dayNames: [
		"Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat",
		"Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
	],
	monthNames: [
		"Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
		"January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
	]
};

// For convenience...
Date.prototype.format = function (mask, utc) {
	return dateFormat(this, mask, utc);
};
////////////////////////////////////////////////////////////////////////////////////////////////



function switch1(){
if (opt === '1' ) { setOpt('0')} else { setOpt('1') };
setThread2("");

};




function switch2(){
  if (opt2 === '1' ) { setOpt2('0')} else { setOpt2('1') }
  
  };
  



    
const newMetric = async () => {
     // alert('new metric!');
      try {

      const result = await API.graphql(graphqlOperation(createMetric, {
          input: {
            bot1: 0,
            bot2: 0,
            bot3: 0,
            bot4: 0
          }
        }));

        setMetricId(result.data.createMetric.id);   


} catch (error) {
console.log('error5 on create metric' , error);
}

};







const modifyMetric = async (tmp) => {
     // alert('update metric type' + tmp); alert('metric id' + metricId)

     //refresh metric
     try {
      var replyData = await API.graphql(graphqlOperation(getMetric    ,   {id: metricId }  ));
 //     console.log(replyData);


///////////

if (tmp === 'bot4') {
  //Incriment bot4
  var tmpBot = replyData.data.getMetric.bot4;
  tmpBot = tmpBot + 1;
  setBot4(tmpBot);
  try {
    const result = await API.graphql(graphqlOperation(updateMetric, {
        input: {
          id: metricId,
          bot4: tmpBot,
        }
      }))

        } catch (error) {
          console.log('error5-4 on create metric' , error);
        }

  
} else if (tmp === 'bot3') {
  //Incriment bot3
  tmpBot = replyData.data.getMetric.bot3;
  tmpBot = tmpBot + 1;
  setBot3(tmpBot);
  try {
    const result = await API.graphql(graphqlOperation(updateMetric, {
        input: {
          id: metricId,
          bot3: tmpBot
          
        }
      }))

        } catch (error) {
          console.log('error5-3 on create metric' , error);
        }

} else if (tmp === 'bot2') {
  //Incriment bot2
  tmpBot = replyData.data.getMetric.bot2;
  tmpBot = tmpBot + 1;
  setBot2(tmpBot);
  try {
    const result = await API.graphql(graphqlOperation(updateMetric, {
        input: {
          id: metricId,
          bot2: tmpBot

        }
      }))

        } catch (error) {
          console.log('error5-2 on create metric' , error);
        }

} else {
  alert('Metric Error 400')
};
//////////

  } catch (error) {
      console.log('error on fetching parent metric', error);
  };


    };



////////////////ASKBOT 2.2 ///////////////////////////////////////
async function askbot2(tmpbot) {
   // alert('askbot2');
   // alert('askbot-start: ' +  comment2)


if (thread2 === "") {alert('Message blank') } else {

  

  
  const genText2 = () => `I want you to tell me if the following message is being mocking, overly sarcastic or is being abusive, harassing, or racist.  Answer in one word if it is, yes or no" 
  
  `
  ;

  var messages=[
   {"role": "system", "content": "you are a helpful assistant that protects users against being trolled, harassed or spammed."},
   {"role": "user", "content": genText2()},
   {"role": "user", "content": thread2},
   
];
 //var raw = JSON.stringify({"model": "gpt-3.5-turbo","messages": [{"role": "user", "content": content}],"temperature":0.7});
 var raw = JSON.stringify({"model": "gpt-4-0613","messages": messages   ,"temperature":0.0});


 //alert('askbot-messages: ' +  messages[0])

 
//alert('askbot-pre fetch');


//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

 var requestOptions = {
     method: 'POST',
     headers: {
             'Content-Type': 'application/json',
           'Authorization': 'Bearer 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'
             },
     body: raw,
     redirect: 'follow',
  };
  


	await fetch("https://api.openai.com/v1/chat/completions", requestOptions)
  .then((response) => response.text())
  .then((responce) => {
   var obj = JSON.parse(responce);
   var tmp1 = JSON.stringify(obj.choices);
   var tmp2 = tmp1.replace(/\[/g,'');
   var tmp3 = tmp2.replace(/\]/g,'');
   
   var tmp4 = JSON.parse(tmp3);
   var tmp5 = tmp4.message.content;
   var tmp6 = JSON.stringify(tmp5)
   var tmp7 = tmp6.replace(/\\"/g,'');
   var tmp8 = tmp7.replace(/\\n/g,'  ');
   
  //alert(tmp8);
   if (tmp8 === '"Yes"' || tmp8 === '"Yes."' || tmp8 === '"yes"' || tmp8 === '"yes."' ) {  alert('Message Rejected for trolling') ;  modifyMetric('bot2'); setLoader('0') }  else { 

    if (tmp8 === '"No"' || tmp8 === '"No."' || tmp8 ==='"no"' || tmp8 === '"no."' ) {  createThread2(tmp8 + " bot3- " + tmpbot) } else { createThread2('ERROR: ' + tmp8 +  " bot3- " + tmpbot) }

};

  
   })
   .catch((error) => {
	alert('BOT ERROR:' + error.message ) 
  })    
   
};

//alert('askbot-end ' + comment2 )

};

//////////////////////////






async function askbot3(tmpbot) {
   // alert('askbot3');
   // alert('askbot-start: ' +  reply2)
  
  
  if (thread2 === "") {alert('Message blank') } else {
  
  const genText2 = () => `I want you to tell me if the following message contains gibberish or random letters and symbols.  Answer in one word if it is, yes or no" 
  
  `
  ;
  
  var messages=[
   {"role": "system", "content": "you are a helpful assistant that protects users against message that hide meaning in gibberish text."},
   {"role": "user", "content": genText2()},
   {"role": "user", "content": thread2},
   
  ];
  //var raw = JSON.stringify({"model": "gpt-3.5-turbo","messages": [{"role": "user", "content": content}],"temperature":0.7});

  var raw = JSON.stringify({"model": "gpt-4-0613","messages": messages   ,"temperature":0.0});


 //alert('askbot-messages: ' +  messages[0])

 
//alert('askbot-pre fetch');


//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

 var requestOptions = {
     method: 'POST',
     headers: {
             'Content-Type': 'application/json',
           'Authorization': 'Bearer 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'
             },
     body: raw,
     redirect: 'follow',
  };
  
  
  
  await fetch("https://api.openai.com/v1/chat/completions", requestOptions)
  .then((response) => response.text())
  .then((responce) => {
   var obj = JSON.parse(responce);
   var tmp1 = JSON.stringify(obj.choices);
   var tmp2 = tmp1.replace(/\[/g,'');
   var tmp3 = tmp2.replace(/\]/g,'');
   
   var tmp4 = JSON.parse(tmp3);
   var tmp5 = tmp4.message.content;
   var tmp6 = JSON.stringify(tmp5)
   var tmp7 = tmp6.replace(/\\"/g,'');
   var tmp8 = tmp7.replace(/\\n/g,'  ');
   
  //alert(tmp8);
   if (tmp8 === '"Yes"' || tmp8 === '"Yes."' || tmp8 === '"yes"' || tmp8 === '"yes."' ) {  alert('Message Rejected for gibberish') ; modifyMetric('bot3'); setLoader('0');  }  else { 
  
    if (tmp8 === '"No"' || tmp8 === '"No."' || tmp8 ==='"no"' || tmp8 === '"no."' ) { askbot2(tmp8 + " bot4- " + tmpbot) } else { askbot2('ERROR: ' + tmp8 +  " bot4- " + tmpbot) }
  
  };
  
  
   })
   .catch((error) => {
  alert('BOT3 ERROR:' + error.message ) 
  })    
   
  };
  
  //alert('askbot-end ' + reply2 )
  
  };
  
  //////////////////////////


  async function askbot4() {
   // alert('askbot4');
   // alert('askbot-start: ' +  reply2)
  
  
  if (thread2 === "") {alert('Message blank') } else {
  
  
  const genText2 = () => `I want you to tell me if the following message is being mocking, overly sarcastic or is being abusive, harassing, or racist.  Answer in one word if it is, yes or no" 
  
  `
  ;

  var messages=[
   {"role": "system", "content": "you are a helpful assistant that protects users against being trolled, harassed or spammed."},
   {"role": "user", "content": genText2()},
   {"role": "user", "content": thread2},
  ];

  //var raw = JSON.stringify({"model": "gpt-3.5-turbo","messages": [{"role": "user", "content": content}],"temperature":0.0});

  var raw = JSON.stringify({"model": "gpt-3.5-turbo","messages": messages   ,"temperature":0.0});


 //alert('askbot4-messages: ' +  messages[0])

 
//alert('askbot4-pre fetch');


//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

 var requestOptions = {
     method: 'POST',
     headers: {
             'Content-Type': 'application/json',
           'Authorization': 'Bearer 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'
             },
     body: raw,
     redirect: 'follow',
  };
  
  
  
  await fetch("https://api.openai.com/v1/chat/completions", requestOptions)
  .then((response) => response.text())
  .then((responce) => {
   var obj = JSON.parse(responce);
   var tmp1 = JSON.stringify(obj.choices);
   var tmp2 = tmp1.replace(/\[/g,'');
   var tmp3 = tmp2.replace(/\]/g,'');
   
   var tmp4 = JSON.parse(tmp3);
   var tmp5 = tmp4.message.content;
   var tmp6 = JSON.stringify(tmp5)
   var tmp7 = tmp6.replace(/\\"/g,'');
   var tmp8 = tmp7.replace(/\\n/g,'  ');
   
  //alert(tmp8);
   if (tmp8 === '"Yes"' || tmp8 === '"Yes."' || tmp8 === '"yes"' || tmp8 === '"yes."' ) { alert('Message Rejected for trolling') ; modifyMetric('bot4'); setLoader('0');  }  else { 
  
    if (tmp8 === '"No"' || tmp8 === '"No."' || tmp8 ==='"no"' || tmp8 === '"no."' ) { askbot3(tmp8) } else {askbot3('ERROR: ' + tmp8) }
  
  };
  
  
   })
   .catch((error) => {
  alert('BOT4 ERROR:' + error.message ) 
  })    
   
  };
  
  //alert('askbot4-end ' + reply2 )
  
  };




//👇🏻 Triggered when the form is submitted
const handleSubmit2 = (e) => {
    e.preventDefault();
    //👇🏻 Calls the function
    //createThread2();
    setLoader('1');
    askbot4();
    //setThread2("");
   
    //navigate(0)
};




async function createThread2(tmp8) {
    const currentDate = new Date();



    try {
     

      const result =  await API.graphql({
        query: createTodo,
        variables: { 
          input: {
            name: Auth.user.attributes.email,
            description: thread2,
            date: currentDate,
            type: "todo",
            rcount: 0,
            bot: tmp8
          }
        },
        authMode: 'AMAZON_COGNITO_USER_POOLS',
    });


          } catch (error) {
            console.log('error5-2 on create metric' , error);
          };
  
    


 
            snotify('Thread Created'); 
           // setLoader('1');
            setOpt('0') ;
            fetchTodos();


            
};


if (opt==='0') {
    var tmpH3 = true;
    var tmpH4 = false
} else {
    tmpH3 = false;
    tmpH4 = true
};



if (opt2 === "1") {
	var tmpH = false
  var tmpHa = true
} else {
	tmpH = true
  tmpHa = false
}

if (loader==='1') {
    var tmpH1 = true;
    var tmpH2 = false;

} else {
    tmpH1 = false;
    tmpH2 = true;

};


if (Auth.user.attributes.email === "rkz@toughguys.biz") {var adminHide = false} else {adminHide = true};

var totalTrolls = bot1 + bot2 + bot3 + bot4 + 100;

    return (
        <>
            <Nav />

        <div style={{backgroundColor:'black', color:'white', minWidth:'96vw', minHeight:'90vh'}}>

         
              
                <br></br>
              <span style={{fontSize:'32px', fontWeight:'bold'}}>
                
              <Image
  alt="img1"
  src={img1}
  backgroundColor="initial"
  height='18px'
  width='18px'
  borderRadius="2px"
  opacity="100%"
  marginRight="10px"
  //onClick={() => alert('📸 Say cheese!')}
/>

                general discussion board</span><br></br>
        <span hidden = {tmpH1} style={{fontSize:'14px', color:"yellow", opacity:'1'}}>trolls prevented: {totalTrolls} <span hidden = {adminHide} style={{paddingLeft:'10px', fontSize:'14px',opacity:'.5'}} >({bot1}-{bot2}-{bot3}-{bot4})</span></span>  
              

            <span hidden = {tmpH1}>



            <div style={{display:"flex", flexDirection:'row' , justifyItems:'center' , justifyContent:'center' ,  alignItems:'center', textAlign:'center', paddingTop:'25px', rowGap:'15px', columnGap:'15px' }}>


<span hidden = {tmpH3}>
           
                <form style={{minWidth:'80vw', maxWidth:'90vw'}}  onSubmit={handleSubmit2}>
                <div >
                        <label htmlFor='thread'>create a new thread</label>

                        <textarea
            rows={5}
            value={thread2}
            onChange={(e) => setThread2(e.target.value)}
            type='text'
            name='thread2'
            className='modalInput'
        />

                 
                    </div>
                    <button className='homeBtn' style={{minWidth:'150px'}}>create thread</button>

                </form>
                <div style={{display:"flex", flexDirection:'column' , alignItems:'center', textAlign:'center', paddingTop:'30px'}}>
    <button className='modalBtn' onClick={switch1} >back</button> 
    </div>
</span>


</div>

<span hidden = {tmpH4}>
<div className='thread__container'>
                    {todos.map((thread,idx) => (
                        <div  style={{	boxShadow: '0 0 0px 0px yellow', display: "flex", flexDirection:'column' , padding:"1vw",backgroundColor:'#416288', minWidth:'90vw', maxWidth:'90vw',  margin:'5px', borderRadius:"3px"}} key={`song${idx}`}>

                            <div style={{ boxShadow: '0 0 0px 0px yellow',  display:"flex", rowGap:'0vw', columnGap:'0vw', flexDirection:'row' , justifyItems:'flex-start' , justifyContent:'space-between',  alignItems:"center", textAlign:'center'}}>
                            
                            <div style={{boxShadow: '0 0 0px 0px green',  display:"flex", flexDirection:'column' ,  minWidth:'40vw',maxWidth:'40vw', textAlign:'left', paddingLeft:'1vw', color:'white', flexWrap:'wrap', rowGap:'15px', columnGap:'15px'}}>{thread.description} </div>
                            <div style={{boxShadow: '0 0 0px 0px green',  display:"flex", flexDirection:'row' , minWidth:'20vw',maxWidth:'20vw', textAlign:'left', color:'white',  fontSize:'12px'}}>updated: {dateFormat(thread.updatedAt, "mmm dd, yyyy @ h:MM:ss TT")}</div>

                            <div style={{boxShadow: '0 0 0px 0px green',  display:"flex", rowGap:'2vw', columnGap:'2vw', flexDirection:'row' , justifyItems:'center' , justifyContent:'center' ,  alignItems:'center', textAlign:'center'}}>
                            <span > 
                          
                                <Comments
                                    numberOfComments={thread.rcount}
                                    threadId={thread.id}
                                    title={thread.description}
                                />
                            </span>
                            <span style={{paddingRight:'0vw'}}> 
                                 <RemoveButton
                                    threadId={thread.id}
                                    name={Auth.user.attributes.email}
                                    author={thread.name}
                                    rcount={thread.rcount}
                                    bot={thread.bot}
                                    opt2={opt2}
                                    threadUpdate={thread.updatedAt}
                                    todos={todos}
                                    funct2={setTodos} 
                                    funct={setLoader} 
                                />
                                </span>
                                </div>

                            </div>
                        </div>
                    ))}
                </div>



    <div style={{display:"flex", flexDirection:'column' , alignItems:'center', textAlign:'center', paddingTop:'30px', paddingBottom: '20px'}}>
    <div style={{display:"flex", flexDirection:'row', rowGap:'15px', columnGap:'2vw'}}>
    <button className='modalBtn' style={{}} onClick={switch1} >new</button> 
    

    <span hidden = {tmpHa} ><button className='modalBtn' onClick={switch2} >edit</button></span>
    <span hidden = {tmpH} ><button  className='modalBtn' style={{color:'black', backgroundColor:'#d4d400'}} onClick={switch2} >edit</button>    </span>

    </div>
    <span hidden = {true}><button  className='modalBtn' style={{minWidth:'120px' , fontSize:'8px'}} onClick={fetchUpdates} >View Update Records</button> </span>
    </div>

   

</span>



</span>

<span hidden = {tmpH2}>

<div className = 'loadingPage'>
<img src={logo} className="App-logo" alt="logo" />

</div>

    </span>


     

            </div>

        </>
    );
};



//export default Home;
//export default withAuthenticator(Home);

export default withAuthenticator(Home, {

  
  components: {
    
    Header,
    SignIn: {
      Header: SignInHeader,
      Footer: SignInFooter
    },
    SignUp: {
      Header: SignUpHeader,
      
    },
    Footer
  }
});
